import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { Observable } from "rxjs";
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { FlexLayoutModule } from "ngx-flexible-layout";

import { TemplateService } from "../../service/template.service";
import { TemplateContent } from "../../model/TemplateRulebook";
import { AlertifyService } from "../../../_models/alertify.service";

@Component({
  selector: "app-list-rulebook",
  templateUrl: "./list-rulebook.component.html",
  styleUrls: ["./list-rulebook.component.css"],
  standalone: false,
})
export class ListRulebookComponent implements OnInit, OnChanges {
  @Input() rbList: TemplateContent[];
  @Input() selected: string;
  @Input() csskey: number;
  @Input() auditName: string;
  @Output() selectedAppkey = new EventEmitter<number>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: TemplateService,
    private alertifyService: AlertifyService,
    private el: ElementRef,
  ) {}

  // Bring the selected rulebook into view within the list's own scroll area (.widget-main),
  // centred, without scrolling the page itself; nothing moves if it's already visible.
  private scrollActiveIntoView(smooth = true) {
    setTimeout(() => {
      const container: HTMLElement =
        this.el.nativeElement.querySelector(".widget-main");
      const activeEl: HTMLElement =
        this.el.nativeElement.querySelector(".widget-main .active");
      if (!container || !activeEl) return;

      const box = container.getBoundingClientRect();
      const item = activeEl.getBoundingClientRect();
      if (item.top >= box.top && item.bottom <= box.bottom) return;

      const top =
        container.scrollTop +
        (item.top - box.top) -
        (container.clientHeight - item.height) / 2;
      container.scrollTo({
        top: Math.max(0, top),
        behavior: smooth ? "smooth" : "auto",
      });
    });
  }

  ngOnInit() {
    this.service.setKey(parseInt(this.selected));
  }

  // Arriving from the audit summary (a rulebook name clicked there) selects a rulebook
  // that may sit far down the list - scroll to it once the list has rendered. Clicks and
  // Previous/Next within the list scroll themselves (smoothly).
  ngOnChanges(changes: SimpleChanges) {
    if (changes.rbList && this.rbList) {
      this.scrollActiveIntoView(false);
    }
  }

  // Rulebook names come from the server HTML-encoded (e.g. "&#44;" for a comma).
  decodeHtml(str: string): string {
    return this.service.decodeHtml(str) ?? "";
  }

  onClickRulebook(appkey: number, rbName: string, abrided: boolean) {
    if (abrided) return;
    //console.log("click on rulebook: " + appkey);
    this.service.setRbName(rbName);
    this.service.setKey(appkey);
    this.selectedAppkey.emit(appkey);
    this.scrollActiveIntoView();
  }

  onBackSummary() {
    var myurl = "audithub/apptool/edit/" + this.csskey;
    this.router.navigateByUrl(myurl).then((err) => {
      console.log(err);
    });
  }

  onNextRulebook() {
    var values = this.service.getNextAppkey();
    if (values != null && values.first != 0) {
      var nextAppkey = values.first;
      var nextRbName = values.second;

      this.service.setKey(nextAppkey);
      this.service.setRbName(nextRbName);
      this.selectedAppkey.emit(nextAppkey);
      this.scrollActiveIntoView();
    } else {
      //alert("You have reached the end of the Applicability Questions!");
      this.alertifyService.warning(
        "You have reached the end of the Applicability Questions!",
      );
    }
  }

  onPreviousRulebook() {
    var values = this.service.getPreviousAppkey();
    if (values != null) {
      var nextAppkey = values.first;
      var nextRbName = values.second;

      this.service.setKey(nextAppkey);
      this.service.setRbName(nextRbName);
      this.selectedAppkey.emit(nextAppkey);
      this.scrollActiveIntoView();
    } else {
      //alert("You have reached the end of the Applicability Questions!");
      this.alertifyService.warning(
        "You have reached the beginning of the Applicability Questions!",
      );
    }
  }
}
